import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-invoice-creation-action',
    templateUrl: './invoice-creation-action.component.html',
    styleUrls: ['./invoice-creation-action.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, MatIconModule]
})

export class InvoiceCreationActionComponent {

	@Output() submitEmitter = new EventEmitter<string>();	// Emits the triggered action

	onActionBarAction(action: string) {
		console.log("InvoiceCreationActionComponent - onActionBarAction: " + action);
		this.submitEmitter.emit(action);
	}

}